module.exports = __webpack_public_path__ + "img/img_item_02.6feb498d.jpg";